import React from 'react'
import { useGLTF } from '@react-three/drei'
import TransitionMaterialFree from './MeshTransitionMaterialFree/MeshTransitionMaterialFree'

export default function ModelCompact({ transitionColor, ...props }) {
  const { nodes, materials } = useGLTF('/models/xbox-c.glb')

  return (
    <group {...props} dispose={null}>
      <group name="Sketchfab_Scene">
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, -0.5]}>
          <group name="a555c13a1d3f4c269996b6c3ce8d3e86fbx" rotation={[Math.PI / 2, 0, 0]}>
            <group name="RootNode">
              <group
                name="Cylinder"
                position={[-2.011, -1.043, 2.152]}
                rotation={[-0.268, -0.033, 0.008]}
                scale={100.706}>
                <mesh
                  name="Cylinder_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cylinder_TT_checker_1024x1024_UV_GRID_0.geometry}>
                  <TransitionMaterialFree
                    roughness={0.2}
                    transitionColor={transitionColor}
                    metalness={1}
                    transitionTime={0.25}
                  />
                </mesh>
              </group>
              <group
                name="Cube002"
                position={[-3.94, 1.498, 1.328]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Cube002_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube002_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Circle002"
                position={[3.104, 1.312, 1.164]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle002_glass_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle002_glass_0.geometry}
                  material={materials.glass}
                />
              </group>
              <group
                name="Circle003"
                position={[3.104, 1.312, 1.164]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle003_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle003_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Circle004"
                position={[3.104, 1.312, 1.164]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle004_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle004_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Circle006"
                position={[3.104, 1.312, 1.164]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle006_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle006_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Circle007"
                position={[3.104, 1.312, 1.164]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle007_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle007_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Circle008"
                position={[3.104, 1.312, 1.164]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle008_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle008_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Cube003"
                position={[0, 3.353, -0.822]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Cube003_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube003_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Plane001"
                position={[-2.014, -1.853, 0.857]}
                rotation={[-0.432, -0.042, 0.007]}
                scale={100}>
                <mesh
                  name="Plane001_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Plane001_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Circle009"
                position={[3.104, 1.312, 1.164]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle009_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle009_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Text"
                position={[2.425, 1.45, 1.453]}
                rotation={[-0.428, 0, 0]}
                scale={0.807}>
                <mesh
                  name="Text_Material001_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Text_Material001_0.geometry}
                />
              </group>
              <group
                name="Text001"
                position={[3.595, 2.428, 1.007]}
                rotation={[-0.428, 0, 0]}
                scale={0.807}>
                <mesh
                  name="Text001_Material001_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Text001_Material001_0.geometry}
                />
              </group>
              <group
                name="Text002"
                position={[4.633, 1.302, 1.105]}
                rotation={[-0.502, 0.37, 0.027]}
                scale={0.896}>
                <mesh
                  name="Text002_Material001_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Text002_Material001_0.geometry}
                />
              </group>
              <group
                name="Text003"
                position={[3.574, 0.438, 1.914]}
                rotation={[-0.428, 0, 0]}
                scale={0.807}>
                <mesh
                  name="Text003_Material001_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Text003_Material001_0.geometry}
                />
              </group>
              <group
                name="Circle010"
                position={[-0.006, -0.298, 0.078]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle010_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle010_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Cube005"
                position={[1.98, -0.796, 2.259]}
                rotation={[-0.299, 0, 0]}
                scale={100}>
                <mesh
                  name="Cube005_TT_checker_1024x1024_UV_GRID_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube005_TT_checker_1024x1024_UV_GRID_0.geometry}
                  material={materials.TT_checker_1024x1024_UV_GRID}
                />
              </group>
              <group
                name="Circle011"
                position={[-0.006, -0.297, 0.08]}
                rotation={[-0.428, 0, 0]}
                scale={100}>
                <mesh
                  name="Circle011_TT_checker_1024x1024_UV_GRID001_0"
                  castShadow
                  receiveShadow
                  geometry={nodes.Circle011_TT_checker_1024x1024_UV_GRID001_0.geometry}>
                  <TransitionMaterialFree
                    roughness={0.3}
                    transitionColor={transitionColor}
                    metalness={1}
                  />
                </mesh>
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/xbox-c.glb')
